
















































import { Vue, Component, Prop } from 'vue-property-decorator';
import DatePickerMonthYear from '@/shared/date-picker/date-picker-month-year.component.vue';

@Component({
  components: {
    DatePickerMonthYear,
  },
})
export default class FeeDiscountCompetenceComponent extends Vue {
  @Prop({ type: String, required: true }) label!: string;

  @Prop({ type: Boolean, required: true }) disabled!: boolean;

  @Prop({ type: Boolean, default: false }) isAdministrator!: boolean;

  @Prop({ type: Boolean, default: false }) isAdministratorOrSupervisorOrGp!: boolean;

  @Prop({ type: String, required: true }) periodStart!: string;

  @Prop({ type: String, required: true }) periodEnd!: string;

  emitCompetenceStartUpdate(value: string): void {
    this.$emit('update:periodStart', value);
  }

  emitCompetenceEndUpdate(value: string): void {
    this.$emit('update:periodEnd', value);
  }

  emitBothCompetences(value: string): void {
    this.emitCompetenceStartUpdate(value);
    this.emitCompetenceEndUpdate(value);
  }
}
